export default __webpack_public_path__ + "static/media/four.673a118c.svg";